/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react';
import { Reseller } from '../../core/_models';

type Props = {
  reseller: Reseller;
};

const ParentResellerInfoCell: FC<Props> = ({ reseller }) => {
  return (
    <div
      className="d-flex align-items-center p-2 rounded border shadow-sm"
      style={{ borderColor: '#ccc' }} // Light gray border
    >
      {/* Reseller Info */}
      <div className="d-flex flex-column">
        <span className="fw-semibold text-dark mb-1" style={{ fontSize: '0.9rem' }}>
          {reseller.parent_reseller_name}
        </span>
        <span className="text-muted" style={{ fontSize: '0.8rem' }}>
          {reseller.parent_reseller_phone}
        </span>
      </div>
    </div>
  );
};

export { ParentResellerInfoCell };
